import React from 'react'
import { Link } from 'react-router-dom'

export default function RishikeshAbout({aboutData}) {
  return (
    <>
    <section className="rishikesh-about">
        <div className="big-container">
            <div className="row justify-content-between">
                
                <div className="col-lg-5 col-sm-6 col-md-6">
                    <div className="rishabout-detail wow animate__animated animate__slideInLeft" data-wow-delay="0.1s" data-wow-duration="1.1s">
                        {aboutData?.title && <span className='sub-title'>{aboutData.title}</span> }
                        <h1 className='heading'>{aboutData?.heading}</h1>
                        <p>{aboutData?.desc}</p>
                        <Link to={aboutData?.Link} 
                            target={aboutData?.target || "_self"}
                            rel={aboutData?.target === "_blank" ? "noopener noreferrer" : ""} 
                            className="arrow-butn">{aboutData.Linktext} <img src="/image/right-arrow.svg" alt="arrow" />
                        </Link>
                    </div>

                    <div className="rishabout-image">
                        <img src={aboutData.Image1} className="img-responsive" alt="rishikesh" loading="lazy"/>
                        <img src="/image/leaf-shape.webp" className="leaf-image" alt="leaf" loading="lazy"/>
                    </div>
                </div>

                <div className="col-lg-6 col-sm-6 col-md-6">
                    <img src={aboutData.Image2} className="img-responsive" alt="rishikesh" loading="lazy"/>
                </div>

            </div>
        </div>

        <img src="/image/flower-shape.webp" className="flower-image" alt="leaf" loading="lazy"/>
    </section>
    </>
  )
}
